import { IClaimType } from "../../claim-type/models/claim-type.model";

export interface IServiceType {
  serviceTypeId: string,
  nameEnglish: string,
  nameArabic: string,
  standardNameId: string,
  standardNameEnglish: string,
  standardNameArabic: string,
  claimTypeIds: string[],
  claimTypeDetails: IClaimType[]
}

export const serviceTypeConfig = {
  entityName: 'CONFIGURATION.SERVICE_TYPE.TITLE',
  nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
  nameArabic: 'FORM_FIELD.ARABIC_NAME',
  standardName: 'CONFIGURATION.MASTER_DATA.STANDARD_NAME.TITLE',
  claimType: 'CONFIGURATION.CLAIM_TYPE.TITLE'
};